import { render, staticRenderFns } from "./CourseManage.vue?vue&type=template&id=94c9ce60&scoped=true"
import script from "./CourseManage.vue?vue&type=script&lang=js"
export * from "./CourseManage.vue?vue&type=script&lang=js"
import style0 from "./CourseManage.vue?vue&type=style&index=0&id=94c9ce60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c9ce60",
  null
  
)

export default component.exports